/*** Handle Card Theme*/
export const handleCardTheme = (tempState) => {
  let codeTheme = tempState.theme.codeTheme.filter((val) => val.selected)[0]
    .theme;
  tempState.theme.cardTheme.forEach((val) => (val.selected = false));
  tempState.theme.cardTheme.forEach((val) =>
    val.value === codeTheme ? (val.selected = true) : null
  );
  return tempState;
};



/*** Get Value*/

export const getValue = (state, tree, menu) => {
  let tempState = menu ? [...state] : { ...state };
  let tempArr = menu
    ? tempState
    : tree.includes("font")
    ? tempState[tree[0]][tree[1]][tree[2]]
    : tempState[tree[0]][tree[1]];
  return tempArr.filter((val) => val.selected)[0];
};

/*** Handle Change*/

export const handleChange = (value, state, tree) => {
  let tempState = { ...state };
  tempState[tree] = value;
  return tempState;
};

/*** Handle Background Color*/
export const handleBackgroundColor = (value, state, status) => {
  let tempState = { ...state };
  tempState.theme.backgroundNoFill = false;
  let tempObj = {
    id: value,
    value,
    selected: true,
    [status]: status ? true : false,
  };
  if (status === "image") {
    let url = URL.createObjectURL(value);
    tempObj.value = url;
    tempObj.id = url;
  }
  tempState.theme.background.forEach((item) => {
    item.selected = false;
  });
  let isPropertyExist = false;
  tempState.theme.background.forEach((item) => {
    if (item.value === value) {
      item.selected = true;
      isPropertyExist = true;
    }
  });
  if (!isPropertyExist) {
    tempState.theme.background.push(tempObj);
  }
  return tempState;
};

/*** Handle Background No Fill*/
export const handleBackgroundNoFill = (state) => {
  let tempState = { ...state };
  tempState.theme.background.forEach((item) => (item.selected = false));
  tempState.theme.backgroundNoFill = true;
  return tempState;
};
